import { useLanguage } from '@/contexts/LanguageContext';
import { Card } from '@/components/ui/card';
import restaurantImage from '@/assets/restaurant-interior.jpg';
import foodTruckImage from '@/assets/food-truck-night.webp';

const About = () => {
  const { t } = useLanguage();

  return (
    <main>
      {/* Hero */}
      <section className="bg-hero-gradient text-white py-12 md:py-20 px-4">
        <div className="container mx-auto text-center">
          <h1 className="text-3xl md:text-5xl font-bold font-['Playfair_Display'] mb-3 md:mb-4">
            {t('aboutTitle')}
          </h1>
          <p className="text-base md:text-xl text-white/90">
            {t('aboutSubtitle')}
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-8 md:py-16 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center mb-8 md:mb-16">
            <div>
              <h2 className="text-xl md:text-3xl font-bold font-['Playfair_Display'] text-primary mb-4 md:mb-6">
                {t('ourStory')}
              </h2>
              <div className="space-y-3 md:space-y-4 text-sm md:text-lg text-muted-foreground leading-relaxed">
                <p>
                  Junnior's Tacos Mexican Restaurant is a family-owned Hispanic restaurant built from a 
                  dream to share authentic Latin flavors with our community in Carrollton, GA.
                </p>
                <p>
                  Our restaurant serves homemade recipes inspired by family traditions passed down through 
                  generations. Every dish is prepared with passion and care, using the finest fresh ingredients 
                  and traditional cooking methods.
                </p>
                <p>
                  From our signature tacos to our flavorful burritos and specialties, we bring the authentic 
                  taste of Mexico to your table. Each bite feels like home, and every visit is a celebration 
                  of family, tradition, and delicious food.
                </p>
              </div>
            </div>
            <div>
              <img
                src={restaurantImage}
                alt="Restaurant interior"
                className="rounded-lg shadow-xl"
              />
            </div>
          </div>

          {/* Mission */}
          <Card className="p-6 md:p-12 bg-warm-gradient mb-8 md:mb-16">
            <h2 className="text-xl md:text-3xl font-bold font-['Playfair_Display'] text-center text-primary mb-4 md:mb-6">
              {t('ourMission')}
            </h2>
            <p className="text-base md:text-xl text-center text-muted-foreground max-w-3xl mx-auto">
              {t('missionText')}
            </p>
          </Card>

          {/* Our Commitment */}
          <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center">
            <div className="order-2 md:order-1">
              <img
                src={foodTruckImage}
                alt="Authentic Mexican cuisine"
                className="rounded-lg shadow-xl"
              />
            </div>
            <div className="order-1 md:order-2">
              <h2 className="text-xl md:text-3xl font-bold font-['Playfair_Display'] text-accent mb-4 md:mb-6">
                Our Commitment to Authenticity
              </h2>
              <div className="space-y-3 md:space-y-4 text-sm md:text-lg text-muted-foreground leading-relaxed">
                <p>
                  At Junnior's Tacos, authenticity is at the heart of everything we do. We use only the 
                  freshest ingredients and traditional cooking techniques to bring you the true flavors of Mexico.
                </p>
                <p>
                  Our recipes have been perfected over time, honoring the culinary traditions of our heritage 
                  while creating a warm, welcoming atmosphere for families and friends to gather and enjoy 
                  great food together.
                </p>
                <p>
                  Whether you're joining us for lunch, dinner, or a special celebration, we're committed to 
                  making every meal memorable with authentic flavors that remind you of home.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
